// src/graphql/queries/lookupQueries.js
// CPV, NUTS, and autocomplete lookup queries

export const getCpvCodes = () => `query GetCpvCodes($query: String, $limit: Int) {
    cpvCodes(query: $query, limit: $limit) {
        code
        descriptionEN
        descriptionDE
    }
}`;

export const getCpvCode = () => `query GetCpvCode($code: String!) {
    cpvCode(code: $code) {
        code
        descriptionEN
        descriptionDE
    }
}`;

export const getCpvParents = () => `query GetCpvParents($code: String!, $depth: Int) {
    cpvParents(code: $code, depth: $depth) {
        code
        descriptionEN
        descriptionDE
    }
}`;

export const getCpvChildren = () => `query GetCpvChildren($code: String!, $depth: Int) {
    cpvChildren(code: $code, depth: $depth) {
        code
        descriptionEN
        descriptionDE
    }
}`;

export const getNutsCodes = () => `query GetNutsCodes($query: String, $limit: Int) {
    nutsCodes(query: $query, limit: $limit) {
        code
        label
    }
}`;

export const getNutsCode = () => `query GetNutsCode($code: String!) {
    nutsCode(code: $code) {
        code
        label
    }
}`;

export const getAutocomplete = () => `query GetAutocomplete($input: AutocompleteInput!) {
    autocomplete(input: $input) {
        value
        label
        hint
    }
}`;

export const getCpvTree = () => `query GetCpvTree($input: CPVTreeInput) {
    cpvTree(input: $input) {
        tree {
            code
            labelEN
            labelDE
            level
            countDirect
            countTotal
            children {
                code
                labelEN
                labelDE
                level
                countDirect
                countTotal
                children {
                    code
                    labelEN
                    labelDE
                    level
                    countDirect
                    countTotal
                }
            }
        }
        totalCount
        buildTime
    }
}`;
